<template>
  <div>
    <!-- 二开页面代码 -->
    <!-- 注:路由请使用PageRouter方式 -->
    <!-- <a href="#" style="color: #409EFF;" @click="bxlxDownLoad">保险合同下载</a> -->
  </div>
</template>
<script>
export default {
  name: 'BxlxDownLoad',
  data() {
    return {
      centerDialogVisible: false
    }
  },
  mounted() {
    debugger
    this.$message.success('xiaz')
    let { fileUniqueCode, FILENAMEFUFFIX } = this.$route.query
    if (fileUniqueCode) {
      this.$message.success('下载中') /
      this.$downloadFile
        .get('http://lstuapis.wiseloong.com/common/document/download', {
          params: {
            fileName: FILENAMEFUFFIX,
            fileUniqueCode,
            doDownload: true
          }
        })
        .then(res => {
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        }).finally(() => {
          setTimeout(() => {
            // 关闭窗口
            parent.closeWindow()
          }, 3000)
        })
    } else {
      this.$message.error('文件不存在')
      setTimeout(() => {
        // 关闭窗口
        parent.closeWindow()
      }, 3000)
    }
  },
  methods: {

  }
}
</script>
